<!-- heating.burners.0.activation -->
<ng-container *ngIf="heatingBurnersActivation$ | async | ready as feature">
  <div class="toggle-wrapper">
    <div>
      {{ '+INSTALLATIONS.INSTALLATION.ECOTRONIC.TOGGLE_LABEL' | translate }}
    </div>
    <mat-slide-toggle
      *ngrxLet="ecotronicStandbyModeToggle$ as toggleValue"
      (click)="onEcotronicToggleChange(feature, toggleValue)"
      [formControl]="ecotronicToggleControl"
    ></mat-slide-toggle>
  </div>
</ng-container>

<!-- heating.burners.0.errorStatus -->
<div class="flex flex-row xs:flex-col justify-between items-center xs:justify-start xs:items-start">
  <div *ngIf="title">
    <h2>
      {{
        device.shortDeviceName
          ? title
          : title + ' ' + (memberId$ | async | value2: featurePropertyKey.value:'')
      }}
    </h2>
    <vi-text *ngIf="isV2Cascade">{{ device.boilerSerial }}</vi-text>
  </div>

  <div
    *ngIf="comfortEnsuringMode$ | async | ready as feature"
    class="flex flex-row gap-[4px] justify-start items-center"
  >
    <div>
      {{
        feature?.properties?.activated?.value
          ? ('+INSTALLATIONS.INSTALLATION.BOILER.COMFORT_ENSURING_MODE.DEACTIVATE' | translate)
          : ('+INSTALLATIONS.INSTALLATION.BOILER.COMFORT_ENSURING_MODE.ACTIVATE' | translate)
      }}
    </div>
    <div
      gtm="onToggle"
      gtmAction="Comfort Ensuring Mode"
      gtmCategory="systemDetails"
      [viConfirm]="{
        title: '+INSTALLATIONS.INSTALLATION.BOILER.COMFORT_ENSURING_MODE.CONFIRM.TITLE' | translate,
        content:
          '+INSTALLATIONS.INSTALLATION.BOILER.COMFORT_ENSURING_MODE.CONFIRM.CONTENT' | translate,
        cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
        confirmBtn: 'GENERAL.BUTTON.ACTIVATE' | translate,
        displayDialog: !feature?.properties?.activated?.value
      }"
      (confirm)="
        onComfortEnsuringModeActivate(comfortEnsuringToggle, feature.properties?.activated?.value)
      "
      (cancel)="cancelActivationComfortEnsuringMode()"
      (click)="onComfortEnsuringModeDeactivate($event, feature.properties?.activated?.value)"
    >
      <mat-slide-toggle
        data-at-toggle-comfort-ensuring-mode
        #comfortEnsuringToggle
        [disabled]="comfortEnsuringModeUpdatePending$ | async"
        [checked]="feature?.properties?.activated?.value"
        (change)="onComfortEnsuringSwitchChange(comfortEnsuringToggle)"
      ></mat-slide-toggle>
    </div>
  </div>
</div>

<ng-container *ngIf="deviceRemoteReset$ | async as feature">
  <div *ngIf="feature | ready | executable: featureCommands.remoteReset" class="flex items-center">
    <button
      data-at-reboot-device-btn
      mat-stroked-button
      gtm="onOpen"
      gtmAction="Reboot device modal"
      gtmCategory="system"
      [viConfirm]="{
        title: '+INSTALLATIONS.INSTALLATION.DEVICE.REBOOT.DIALOG.TITLE' | translate,
        content: '+INSTALLATIONS.INSTALLATION.DEVICE.REBOOT.DIALOG.MESSAGE' | translate,
        cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
        confirmBtn: 'GENERAL.BUTTON.REBOOT_DEVICE' | translate
      }"
      (confirm)="rebootDevice()"
      (cancel)="cancelRebootDeviceConfirmation()"
    >
      {{ 'GENERAL.BUTTON.REBOOT_DEVICE' | translate }}
    </button>
    <mat-icon
      class="ml-1"
      [matTooltip]="'+INSTALLATIONS.INSTALLATION.DEVICE.REBOOT.TOOLTIP' | translate"
      >info</mat-icon
    >
  </div>
</ng-container>

<app-lecture-code-address-panel
  *ngIf="burnerErrorStatus$ | async | ready as feature"
  [feature]="feature"
></app-lecture-code-address-panel>

<vi-alert *ngIf="devicesStore.isVitovalorPA2Device$ | async" [type]="alertTypeInfo">
  {{ '+INSTALLATIONS.INSTALLATION.SYSTEM.NO_ADDITIONAL_DATA_AVAILABLE' | translate }}
</vi-alert>

<app-ecotronic-details *ngIf="devicesStore.isEcotronicDevice$ | async"></app-ecotronic-details>

<app-feature-list-container>
  <div class="feature-grid-container" viFeatureGrid viBorderBottom>
    <!-- marketing name -->
    <app-feature-list-item
      *ngIf="device"
      data-at-marketing-name
      label="{{ '+INSTALLATIONS.INSTALLATION.MARKETING_NAME' | translate }}:"
      [value]="device.marketingName | dash"
    >
    </app-feature-list-item>

    <ng-container *ngIf="isVitopureDevice$ | async">
      <app-feature-list-item
        *ngIf="heatExchangerfrostProtection$ | async | ready as feature"
        data-at-heat-exchanger-frost-protection
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_HEAT_EXCHANGER_FROST_DAMAGE_PREVENTION_STATUS'
            | translate
        }}:"
        [value]="feature.properties?.status?.value | translateState | uppercase"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>

      <!-- Filter status [OK / NOT OK] -->
      <app-feature-list-item
        *ngIf="filterRuntime$ | async | ready as feature"
        data-at-filter-status
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_FILTER_STATUS' | translate
        }}:"
        value="{{
          feature.properties?.overdueHours?.value > 0
            ? ('GENERAL.NOT_OK' | translate)
            : ('GENERAL.OK' | translate)
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>

      <!-- Value: Operating hours ventilation engines -->
      <!-- ventilation.preHeater.statistics -->
      <app-feature-list-item
        *ngIf="preHeaterStatistics$ | async | ready as feature"
        data-at-engines-operating-hours
        label="{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_ENGINES_OPERATING_HOURS'
            | translate
        }}:"
        value="{{ feature | value2: featurePropertyKey.hours }} {{
          feature | unit: featurePropertyKey.hours
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>

      <!-- Filter lifetime -->
      <ng-container *ngIf="filterRuntime$ | async | ready as feature">
        <!-- Filter operating hours -->
        <app-feature-list-item
          data-at-filter-operating-hours
          label="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_FILTER_OPERATING_HOURS'
              | translate
          }}:"
          value="{{
            VentilationDiagnosticsHelpers.convertFilterRuntimeHours(
              feature.properties?.operatingHours?.value,
              false
            )
          }}"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-list-item>
        <!-- Filter remaining runtime hours -->
        <app-feature-list-item
          *ngIf="
            Number(feature.properties?.overdueHours?.value | toFixed: 0) > 0;
            else remainingHours
          "
          class="error"
          data-at-filter-overdue-hours
          label="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_FILTER_REMAINING_LIFETIME'
              | translate
          }}:"
          value="{{
            VentilationDiagnosticsHelpers.convertFilterRuntimeHours(
              feature.properties?.overdueHours?.value,
              true
            )
          }}"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-list-item>
        <ng-template #remainingHours>
          <app-feature-list-item
            data-at-filter-remaining-hours
            label="{{
              '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_FILTER_REMAINING_LIFETIME'
                | translate
            }}:"
            value="{{
              VentilationDiagnosticsHelpers.convertFilterRuntimeHours(
                feature.properties?.remainingHours?.value,
                false
              )
            }}"
            [attr.data-feature]="feature.feature"
            [error]="feature | error"
          >
          </app-feature-list-item>
        </ng-template>
        <!-- Date last filter change -->
        <!-- ventilation.filter.runtime -->
        <app-feature-list-item
          *ngIf="lastFilterChange$ | async as date"
          data-at-last-filter-change
          label="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_LAST_FILTER_CHANGE'
              | translate
          }}:"
          value="{{ date | date: 'shortDate' }}"
          labelInfoTooltip="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_LAST_FILTER_CHANGE_TOOLTIP'
              | translate
          }}"
          [attr.data-feature]="'lastFilterChange'"
        >
        </app-feature-list-item>

        <!-- Date next filter change -->
        <!-- ventilation.filter.runtime -->
        <app-feature-list-item
          *ngIf="nextFilterChange$ | async as date"
          data-at-next-filter-change
          label="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_NEXT_FILTER_CHANGE'
              | translate
          }}:"
          labelInfoTooltip="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_NEXT_FILTER_CHANGE_TOOLTIP'
              | translate
          }}"
          value="{{ date | date: 'shortDate' }}"
          [attr.data-feature]="'nextFilterChange'"
        >
        </app-feature-list-item>
      </ng-container>
    </ng-container>

    <!-- heating.compressors.0 -->
    <app-feature-list-item
      *ngIf="compressor$ | async | ready as feature"
      data-at-compressor-item
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.COMPRESSOR.LABEL' | translate }}:"
      [value]="
        feature.properties?.active?.value
          | booleanSuffix
            : [
                customTranslationsService.STATE.on | translate,
                customTranslationsService.STATE.off | translate
              ]
      "
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.device.smartGrid -->
    <app-feature-list-item
      *ngIf="
        device?.deviceType === heatingDevice &&
        (devicesStore.heatPumpSmartGrid$ | async) as smartGridValue
      "
      data-at-smart-grid
      label="{{ '+INSTALLATIONS.INSTALLATION.HEAT_PUMP.SMART_GRID.TITLE' | translate }}:"
      value="{{
        '+INSTALLATIONS.INSTALLATION.HEAT_PUMP.SMART_GRID.VALUES.' + smartGridValue.toUpperCase()
          | translate
          | unknownModeDash
      }}"
      valueInfoTooltip="{{
        '+INSTALLATIONS.INSTALLATION.HEAT_PUMP.SMART_GRID.DESCRIPTIONS.' +
          smartGridValue.toUpperCase()
          | translate
          | unknownModeDash
      }}"
    >
    </app-feature-list-item>

    <!-- device.offPeak -->
    <app-feature-list-item
      *ngIf="offPeakSignal$ | async | ready as feature"
      [attr.data-at-device-pvSignal-active]="feature.properties?.currentState?.value"
      data-at-refrigerant-circuit-panel-feature="offPeak"
      [attr.data-feature]="feature.feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.OFF_PEAK_SIGNAL.TITLE' | translate }}:"
      value="{{
        feature.properties?.currentState?.value === offPeakSignal.economyTariff
          ? ('+INSTALLATIONS.INSTALLATION.OFF_PEAK_SIGNAL.ECONOMY' | translate)
          : ('+INSTALLATIONS.INSTALLATION.OFF_PEAK_SIGNAL.PREMIUM' | translate)
      }}"
    ></app-feature-list-item>

    <!-- device.pvSignal.active -->
    <app-feature-list-item
      *ngIf="pvSignal$ | async | ready as feature"
      [attr.data-at-device-pvSignal-active]="feature.properties?.currentState?.value"
      [attr.data-feature]="feature.feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.PHOTOVOLTAIC_ACTIVE.TITLE' | translate }}:"
      value="{{
        feature.properties?.currentState?.value === pvAvailable
          ? ('+INSTALLATIONS.INSTALLATION.PV_SIGNAL_ACTIVE_STATUS' | translate)
          : ('+INSTALLATIONS.INSTALLATION.PV_SIGNAL_NOT_ACTIVE_STATUS' | translate)
      }}"
    ></app-feature-list-item>

    <!-- heating.noise.reduction.operating.programs.active -->
    <app-feature-list-item
      *ngIf="heatingNoiseReduction$ | async as mode"
      [attr.data-at-noise-reduction]="mode"
      label="{{ '+INSTALLATIONS.INSTALLATION.HEAT_PUMP.NOISE_REDUCTION.TITLE' | translate }}:"
      value="{{
        '+INSTALLATIONS.INSTALLATION.HEAT_PUMP.NOISE_REDUCTION.VALUES.' + mode.toUpperCase()
          | translate
      }}"
    >
    </app-feature-list-item>

    <!-- heating.primaryCircuit.spaceFrostProtection -->
    <ng-container feature *ngIf="spaceFrostProtection$ | async | ready as feature">
      <app-feature-list-item
        feature
        [attr.data-at-space-frost-protection]="feature.properties?.active?.value"
        [label]="
          ('+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.STATUS.SPACE_FROST_PROTECTION'
            | translate) + ':'
        "
        [value]="
          feature.properties?.active?.value
            | booleanSuffix
              : [
                  customTranslationsService.STATE.on | translate,
                  customTranslationsService.STATE.off | translate
                ]
        "
      ></app-feature-list-item>
    </ng-container>

    <!-- heating.dhw.dhwCylinder.frostprotection -->
    <ng-container feature *ngIf="frostProtection$ | async | ready as feature">
      <app-feature-list-item
        feature
        [attr.data-at-frost-protection]="feature.properties?.status?.value"
        [label]="
          ('+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.STATUS.DHW_FROST_PROTECTION'
            | translate) + ':'
        "
        [value]="
          feature.properties?.status?.value === OnOff.on
            | booleanSuffix
              : [
                  customTranslationsService.STATE.on | translate,
                  customTranslationsService.STATE.off | translate
                ]
        "
      ></app-feature-list-item>
    </ng-container>

    <!-- heating.sensors.pressure.supply -->
    <app-feature-list-item
      *ngIf="waterPressure$ | async | ready as feature"
      data-at-water-pressure-item
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.WATER_PRESSURE' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.sensors.temperature.outside -->
    <app-feature-list-item
      *ngIf="outsideTemperature$ | async | ready as feature"
      data-at-outside-item
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.OUTSIDE_TEMPERATURE' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.cascade.temperature.commonSupply -->
    <!-- if not lead device then -->
    <!-- heating.boiler.sensors.temperature.commonSupply -->
    <ng-template
      [ngIf]="device?.isLeadDeviceInCascades"
      [ngIfElse]="commonFlowTemperature"
      data-at-common-flow-item
    >
      <app-feature-list-item
        *ngIf="leadDeviceCommonSupply$ | async | ready as feature"
        label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.COMMON_FLOW_TEMPERATURE' | translate }}:"
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>
    </ng-template>

    <ng-template #commonFlowTemperature data-at-common-flow-item>
      <app-feature-list-item
        *ngIf="commonFlowTemperature$ | async | ready as feature"
        data-at-common-flow-item
        label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.COMMON_FLOW_TEMPERATURE' | translate }}:"
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>
    </ng-template>

    <!-- heating.sensors.temperature.return -->
    <app-feature-list-item
      *ngIf="returnFlowTemperature$ | async | ready as feature"
      data-at-return-flow-item
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.RETURN_FLOW_TEMPERATURE' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.burners.0 -->
    <app-feature-list-item
      *ngIf="burner$ | async | ready as feature"
      data-at-burner-item
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.BURNER' | translate }}:"
      [value]="
        feature.properties?.active?.value
          | booleanSuffix
            : [
                customTranslationsService.STATE.on | translate,
                customTranslationsService.STATE.off | translate
              ]
      "
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.secondaryCircuit.sensors.temperature.supply -->
    <app-feature-list-item
      *ngIf="secondaryCircuitSupplyTemperature$ | async | ready as feature"
      data-at-secondary-circuit-supply-temperature-item
      label="{{
        '+INSTALLATIONS.INSTALLATION.BOILER.SECONDARY_CIRCUIT_SUPPLY_TEMPERATURE' | translate
      }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.burners.0.statistics -->
    <ng-container *ngIf="burnerStatistics$ | async | ready as feature">
      <!-- heating.burners.0.statistics.hours -->
      <app-feature-list-item
        data-at-burner-hours-item
        label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.BURNER_HOURS' | translate }}:"
        value="{{ feature | value2: featurePropertyKey.hours }} {{
          feature | unit: featurePropertyKey.hours
        }}"
        [attr.data-feature]="feature.feature + '/hours'"
        [error]="feature | error"
      >
      </app-feature-list-item>

      <!-- heating.burners.0.statistics.starts -->
      <app-feature-list-item
        data-at-burner-runs-item
        label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.BURNER_RUNS' | translate }}:"
        [value]="feature.properties?.starts?.value | toFixed: 0"
        [attr.data-feature]="feature.feature + '/starts'"
        [error]="feature | error"
      >
      </app-feature-list-item>

      <app-feature-list-item
        data-at-burner-clocking-item
        label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.BURNER_CLOCKING' | translate }}:"
        [value]="
          calculateClocking(feature.properties?.starts?.value, feature.properties?.hours?.value)
            | minutesOrHours
        "
        [attr.data-feature]="feature.feature + '/calculateClocking'"
        [error]="feature | error"
      >
      </app-feature-list-item>
    </ng-container>

    <!-- heating.burners.0.modulation -->
    <app-feature-list-item
      *ngIf="modulation$ | async | ready as feature"
      data-at-burner-modulation-item
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.BURNER_MODULATION' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>
    <!-- heating.valves.diverter.heatDhw -->
    <app-feature-list-item
      *ngIf="heatDhw$ | async | ready as feature"
      data-at-diverter-valve
      label="{{ '+INSTALLATIONS.INSTALLATION.DIVERTER.WAY.SETPOINT' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.position | diverterValvePipe }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.boiler.sensors.temperature.main -->
    <app-feature-list-item
      *ngIf="boilerTemperature$ | async | ready as feature"
      data-at-boiler-item
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.BOILER_TEMPERATURE' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.outdoor.defrosting -->
    <!-- TODO VIG-3076 commented temporarily -->
    <!-- <app-feature-list-item
      *ngIf="defrosting$ | async | ready as feature"
      data-at-defrosting-item
      label="{{ '+INSTALLATIONS.INSTALLATION.HEATPUMP.DEFROSTING' | translate }}:"
      [value]="
        feature | value: 'active' | booleanSuffix: [customTranslationsService.STATE.on | translate, customTranslationsService.STATE.off  | translate]
      "
      [error]="feature | error"
    >
    </app-feature-list-item> -->

    <!-- pcc.transfer.power.exchange -->
    <app-feature-list-item
      *ngIf="powerGridConnectionPoint$ | async | ready as feature"
      data-at-defrosting-item
      [label]="
        feature.properties?.value.value > 0
          ? ('+INSTALLATIONS.INSTALLATION.VITOCHARGE.POWER_GRID.GRID_CONSUMPTION' | translate) + ':'
          : ('+INSTALLATIONS.INSTALLATION.VITOCHARGE.POWER_GRID.CONNECTION_POINT' | translate) + ':'
      "
      value="{{ feature | value2: featurePropertyKey.value | absoluteValue }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.sensors.temperature.hydraulicSeparator -->
    <ng-container *ngIf="!(devicesStore.isFuelCellDevice$ | async)">
      <app-feature-list-item
        *ngIf="bufferTankTemperetaure$ | async | ready as feature"
        data-at-buffer-tank-temperature-item
        label="{{ '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.BUFFER_TANK.LABEL' | translate }}:"
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>
    </ng-container>

    <!-- heating.buffer.sensors.temperature.main -->
    <ng-container *ngIf="!(devicesStore.isFuelCellDevice$ | async)">
      <app-feature-list-item
        *ngIf="bufferTemperatureMain$ | async | ready as feature"
        data-at-buffer-temperature-main
        label="{{
          '+INSTALLATIONS.INSTALLATION.HEATPUMP.BUFFER_TEMPERATURE_MAIN.LABEL' | translate
        }}:"
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>
    </ng-container>

    <!-- heating.circuits.[0].sensors.humidity.dewpoint -->
    <app-feature-list-item
      *ngIf="humidityDewPoint0$ | async | ready as feature"
      data-at-humudity-dewpoint-item
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.HUMIDITY_DEWPOINT' | translate }} - {{
        'GENERAL.CIRCUIT' | translate
      }} 1:"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.circuits.[1].sensors.humidity.dewpoint -->
    <app-feature-list-item
      *ngIf="humidityDewPoint1$ | async | ready as feature"
      data-at-humudity-dewpoint-item
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.HUMIDITY_DEWPOINT' | translate }} - {{
        'GENERAL.CIRCUIT' | translate
      }} 2:"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- ess.meter.N	 -->
    <app-feature-list-item
      *ngIf="energyMeter$ | async | ready as feature"
      data-at-ess-energy-meter-item
      label="{{ '+INSTALLATIONS.INSTALLATION.VITOCHARGE.ESS.ENERGY_METER' | translate }}:"
      [value]="
        feature.properties?.active?.value
          | booleanSuffix: ['BIVALENT.YES' | translate, 'BIVALENT.NO' | translate]
      "
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- ess.sensors.temperature.ambient	 -->
    <app-feature-list-item
      *ngIf="ambientTemperature$ | async | ready as feature"
      data-at-ess-temperature-ambient-item
      label="{{ '+INSTALLATIONS.INSTALLATION.VITOCHARGE.ESS.AMBIENT_TEMPERATURE' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- ess.configuration.systemType	 -->
    <app-feature-list-item
      *ngIf="essSystemType$ | async | ready as feature"
      data-at-ess-system-type-item
      label="{{ '+INSTALLATIONS.INSTALLATION.ESS_SYSTEM_TYPE.TITLE' | translate }}:"
      [value]="feature.properties?.value?.value | translateEssSystemType"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- device.firmware.version		 -->
    <app-feature-list-item
      *ngIf="essFirmware$ | async | ready as feature"
      data-at-ess-firmware-item
      label="{{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_VERSION.TITLE' | translate }}:"
      value="{{ feature.properties?.value?.value }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>
    <!-- heating.secondaryHeatGenerator.sensors.temperature.separator -->
    <ng-container *ngIf="secondaryHeatGeneratorTemperatureSeparator$ | async | ready as feature">
      <app-feature-list-item
        *ngIf="feature?.properties?.value?.value; else statusDisplay"
        [label]="
          ('+INSTALLATIONS.INSTALLATION.FIRMWARE_VERSION.TEMPERATURE_EXTERNAL.HEAT_GENERATOR'
            | translate) + ':'
        "
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
        [attr.data-feature]="feature?.feature"
      >
      </app-feature-list-item>
      <ng-template #statusDisplay>
        <app-feature-list-item
          [label]="
            ('+INSTALLATIONS.INSTALLATION.FIRMWARE_VERSION.TEMPERATURE_EXTERNAL.HEAT_GENERATOR'
              | translate) + ':'
          "
          value="{{ feature?.properties?.status?.value.toUpperCase() | translateState }}"
          [attr.data-feature]="feature?.feature"
        >
        </app-feature-list-item>
      </ng-template>
    </ng-container>
    <!-- ess.inverter.ac.power.consolidated for cascade device -->
    <app-feature-list-item
      data-at-inverter-power
      *ngIf="
        (devicesStore.shouldUseConsolidatedFeature$ | async) &&
          (inverterPowerConsolidatedFeatures$ | async | ready) &&
          (inverterPowerConsolidatedPerDevice$ | async) as feature;
        else inverterPower
      "
      [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.INVERTER_POWER' | translate"
      value="{{ feature | featureLike | value2: featurePropertyKey.value }} {{
        feature | featureLike | unit: featurePropertyKey.value
      }}"
    ></app-feature-list-item>
    <!-- ess.inverter.ac.power for single vitocharge device -->
    <ng-template #inverterPower>
      <app-feature-list-item
        data-at-inverter-power
        *ngIf="inverterPower$ | async | ready as feature"
        [error]="feature | error"
        [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.INVERTER_POWER' | translate"
        value="{{ feature | value2: featurePropertyKey.activePower }} {{
          feature | unit: featurePropertyKey.activePower
        }}"
        [attr.data-feature]="feature.feature"
      ></app-feature-list-item>
    </ng-template>

    <!-- heating.burners.0.demand.temperature -->
    <app-feature-list-item
      *ngIf="burnerDemandTemperature$ | async as feature"
      data-at-burner-demand-temperature
      label="{{ '+INSTALLATIONS.INSTALLATION.BURNER_DEMAND_TEMPERATURE' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.boiler.ash.level.current -->
    <app-feature-list-item
      *ngIf="heatingBoilerAshLevel$ | async | ready as feature"
      data-at-boiler-ash-level
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.ASH_LEVEL_CURRENT' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- ventilation.heating.recovery -->
    <app-feature-list-item
      *ngIf="ventilationHeatRecovery$ | async | ready as feature"
      data-at-ventilation-heating-recovery
      label="{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.HEAT_RECOVERY' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- ventilation.filter.pollution -->
    <app-feature-list-item
      *ngIf="filterPollution$ | async | ready as feature"
      data-at-ventilation-filter-pollution
      label="{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.FILTER_POLLUTION' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [beta]="feature.feature | beta"
    >
    </app-feature-list-item>

    <!-- ventilation.volumeFlow.current.output/value -->
    <app-feature-list-item
      *ngIf="ventilationVolumeFlowCurrentOutput$ | async | ready as feature"
      data-at-ventilation-volumeflow-current-output
      label="{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.VOLUME_FLOW.EXHAUST_FAN' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- ventilation.fan.exhaust.current -->
    <app-feature-list-item
      *ngIf="ventilationFanExhaust$ | async | ready as feature"
      data-at-ventilation-fan-exhaust
      label="{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.EXHAUST_FAN' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.current }} {{
        feature | sensorStatusConnected | unit: featurePropertyKey.current
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- ventilation.fan.exhaust.runtime -->
    <app-feature-list-item
      *ngIf="ventilationFanExhaustRuntime$ | async | ready as feature"
      data-at-ventilation-fan-exhaust-runtime
      label="{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.EXHAUST_FAN_RUNTIME' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- ventilation.volumeFlow.current.input/value -->
    <app-feature-list-item
      *ngIf="ventilationVolumeFlowCurrentInput$ | async | ready as feature"
      data-at-ventilation-volumeflow-current-input
      label="{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.VOLUME_FLOW.SUPPLY_FAN' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- ventilation.fan.supply.current -->
    <app-feature-list-item
      *ngIf="ventilationFanSupply$ | async | ready as feature"
      data-at-ventilation-fan-supply
      label="{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.SUPPLY_FAN' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.current }} {{
        feature | sensorStatusConnected | unit: featurePropertyKey.current
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- ventilation.fan.supply.runtime -->
    <app-feature-list-item
      *ngIf="ventilationFanSupplyRuntime$ | async | ready as feature"
      data-at-ventilation-fan-supply-runtime
      label="{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.SUPPLY_FAN_RUNTIME' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- heating.primaryCircuit.airSource -->
    <app-feature-list-item
      *ngIf="primaryCircuitAirSource$ | async | ready as feature"
      [attr.data-at-primary-circuit-air-source]="feature | value2: featurePropertyKey?.mode"
      [attr.data-feature]="feature.feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.PRIMARY_CIRCUIT.AIR_SOURCE.TITLE' | translate }}:"
      value="{{
        (
          '+INSTALLATIONS.INSTALLATION.PRIMARY_CIRCUIT.AIR_SOURCE.VALUES.' +
          (feature | value2: featurePropertyKey.mode)
        ).toUpperCase() | translate
      }}"
    >
    </app-feature-list-item>

    <!-- heating.sensors.volumetricFlow.allengra -->
    <ng-container *ngIf="volumetricFlow$ | async | ready as feature">
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.VOLUMETRIC_FLOW.LABEL' | translate }}:"
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
        [attr.data-feature]="feature.feature"
      ></app-feature-list-item>
    </ng-container>

    <!-- device.demand.external -->
    <app-feature-list-item
      *ngIf="deviceDemandExternal$ | async | ready as feature"
      data-at-device-demand-external
      label="{{ '+INSTALLATIONS.INSTALLATION.EXTERNAL_DEMAND.LABEL' | translate }}:"
      value="{{
        feature?.properties?.active?.value
          | booleanSuffix
            : [
                customTranslationsService.STATE.active | translate,
                customTranslationsService.STATE.inactive | translate
              ]
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- device.lock.external -->
    <app-feature-list-item
      *ngIf="deviceLockExternal$ | async | ready as feature"
      data-at-device-lock-external
      label="{{ '+INSTALLATIONS.INSTALLATION.EXTERNAL_LOCK.LABEL' | translate }}:"
      value="{{
        feature?.properties?.active?.value
          | booleanSuffix
            : [
                customTranslationsService.STATE.active | translate,
                customTranslationsService.STATE.inactive | translate
              ]
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- device.demand.external.flow.temperature.setpoint -->
    <app-feature-list-item
      *ngIf="deviceDemandExternalFlowTemperatureSetpoint$ | async | ready as feature"
      data-at-device-demand-externl-flow-temperature-setpoint
      label="{{ '+INSTALLATIONS.INSTALLATION.EXTERNAL_FLOW_TEMPERATURE' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    ></app-feature-list-item>

    <!-- heating.boiler.pumps.internal.target -->
    <app-feature-list-item
      *ngIf="internalHydraulicConfigurationInternalPumps$ | async | ready as feature"
      data-at-heating-boiler-pumps-internal-target
      label="{{ '+INSTALLATIONS.INSTALLATION.INTERNAL_DEFAULT_PUMP.LIMIT' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      data-feature="{{ feature.feature + '/' + featurePropertyKey.value }}"
    >
    </app-feature-list-item>

    <!-- pump limit values -->
    <app-feature-list-item
      *ngIf="configurationDhwCylinderPumps$ | async | ready as feature"
      data-at-heating-configuration-dhwCylinderPump-defaultLimit
      label="{{ '+INSTALLATIONS.INSTALLATION.DHW_CYLINDER_STORAGE_TANK_PUMP.LIMIT' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.defaultLimit }} {{
        feature | unit: featurePropertyKey.defaultLimit
      }}"
      data-feature="{{ feature.feature + '/' + featurePropertyKey.defaultLimit }}"
    >
    </app-feature-list-item>
  </div>
</app-feature-list-container>

<!-- heating.gas.configuration-->
<ng-container
  *ngrxLet="{
    typeFeature: gasRelatedDataType$ | async | ready,
    calorificValueFeature: gasRelatedDataCalorificValue$ | async | ready,
    correctionFactor: gasRelatedDataVolumeCorrectionFactor$ | async | ready,
  } as gasFeatures"
>
  <app-feature-list-container
    *ngIf="
      gasFeatures.typeFeature?.isEnabled ||
      gasFeatures.calorificValueFeature?.isEnabled ||
      gasFeatures.correctionFactor?.isEnabled
    "
    title="{{ '+INSTALLATIONS.INSTALLATION.GAS_RELATED_DATA.SECTION_TITLE' | translate }}"
  >
    <div class="feature-grid-container" viFeatureGrid viBorderBottom>
      <app-feature-list-item
        data-at-gas-configuration-type
        *ngIf="gasFeatures.typeFeature?.isEnabled"
        label="{{ '+INSTALLATIONS.INSTALLATION.GAS_RELATED_DATA.GAS_TYPE.LABEL' | translate }}:"
        value="{{
          gasFeatures.typeFeature | value2: featurePropertyKey.value:null | gasConfigurationType
        }}"
      >
      </app-feature-list-item>

      <app-feature-list-item
        *ngIf="gasFeatures.calorificValueFeature?.isEnabled"
        data-at-gas-calorific-value-feature
        label="{{
          '+INSTALLATIONS.INSTALLATION.GAS_RELATED_DATA.CALORIFIC_VALUE.TITLE' | translate
        }}:"
        value="{{ gasFeatures.calorificValueFeature | value2: featurePropertyKey.value }}"
        [suffix]="suffix.kilowattHourPerCubicMeter"
      >
      </app-feature-list-item>

      <!-- No value2 due to rounding issue -->
      <app-feature-list-item
        *ngIf="gasFeatures.correctionFactor?.isEnabled"
        data-at-gas-correction-factor
        label="{{
          '+INSTALLATIONS.INSTALLATION.GAS_RELATED_DATA.CORRECTION_FACTOR.TITLE' | translate
        }}:"
        value="{{ gasFeatures.correctionFactor.properties.value.value }}"
      >
      </app-feature-list-item>
    </div>
  </app-feature-list-container>
</ng-container>

<ng-container *ngIf="showSystemDetails">
  <app-system-details [device]="device"></app-system-details>
</ng-container>

<!-- Configurations -->
<ng-container *ngIf="isDeviceVitocharge && essConfigurations$ | async | ready">
  <app-system-configurations [device]="device"></app-system-configurations>
</ng-container>

<!-- heating.service.timeBased -->
<ng-container
  *ngIf="
    (devicesStore.isVentilationDevice$ | async) &&
    (heatingServiceTimeBased$ | async | ready) as heatingServiceTimeBased
  "
>
  <app-system-service-interval
    [device]="device"
    [heatingServiceTimeBased]="heatingServiceTimeBased"
  ></app-system-service-interval>
</ng-container>

<ng-container
  *ngIf="
    !(isE3HeatPumpDevice$ | async) &&
    (enabledRefrigerantCircuits$ | async | ready | featureValue: 'enabled') as circuitIds
  "
>
  <app-refrigerant-load-classes-details
    *ngFor="let refrigerantCircuitId of circuitIds"
    [title]="installationService.getRefrigerantCircuitName(refrigerantCircuitId)"
    [refrigerantCircuitId]="refrigerantCircuitId"
  ></app-refrigerant-load-classes-details>
</ng-container>

<ng-container
  *ngrxLet="{
  heatingCopTotal: heatingCopTotal$,
  heatingCopHeating: heatingCopHeating$,
  heatingCopDhw: heatingCopDhw$,
  heatingCopCooling: heatingCopCooling$,
  heatingCopPhotovoltaic: heatingCopPhotovoltaic$,
} as copFeatures"
>
  <app-feature-list-container
    *ngIf="
      copFeatures.heatingCopTotal ||
      copFeatures.heatingCopHeating ||
      copFeatures.heatingCopDhw ||
      copFeatures.heatingCopCooling ||
      copFeatures.heatingCopPhotovoltaic
    "
    title="{{ '+INSTALLATIONS.INSTALLATION.COP.TITLE' | translate }}"
    [tooltipText]="'+INSTALLATIONS.INSTALLATION.COP.TOOLTIP' | translate"
  >
    <div class="feature-grid-container" viFeatureGrid viBorderBottom>
      <app-feature-list-item
        data-at-heating-cop-total
        *ngIf="copFeatures.heatingCopTotal"
        label="{{ '+INSTALLATIONS.INSTALLATION.HEATING.COP.TOTAL' | translate }}:"
        [value]="copFeatures.heatingCopTotal | value2: featurePropertyKey.value"
        [attr.data-feature]="copFeatures.heatingCopTotal.feature"
        [error]="copFeatures.heatingCopTotal | error"
      ></app-feature-list-item>
      <app-feature-list-item
        data-at-heating-cop-heating
        *ngIf="copFeatures.heatingCopHeating"
        label="{{ '+INSTALLATIONS.INSTALLATION.HEATING.COP.HEATING' | translate }}:"
        [value]="copFeatures.heatingCopHeating | value2: featurePropertyKey.value"
        [attr.data-feature]="copFeatures.heatingCopHeating.feature"
        [error]="copFeatures.heatingCopHeating | error"
      ></app-feature-list-item>
      <app-feature-list-item
        data-at-heating-cop-dhw
        *ngIf="copFeatures.heatingCopDhw"
        label="{{ '+INSTALLATIONS.INSTALLATION.HEATING.COP.DHW' | translate }}:"
        [value]="copFeatures.heatingCopDhw | value2: featurePropertyKey.value"
        [attr.data-feature]="copFeatures.heatingCopDhw.feature"
        [error]="copFeatures.heatingCopDhw | error"
      ></app-feature-list-item>
      <app-feature-list-item
        data-at-heating-cop-cooling
        *ngIf="copFeatures.heatingCopCooling"
        label="{{ '+INSTALLATIONS.INSTALLATION.HEATING.COP.COOLING' | translate }}:"
        [value]="copFeatures.heatingCopCooling | value2: featurePropertyKey.value"
        [attr.data-feature]="copFeatures.heatingCopCooling.feature"
        [error]="copFeatures.heatingCopCooling | error"
      ></app-feature-list-item>
      <app-feature-list-item
        data-at-heating-cop-photovoltaic
        *ngIf="copFeatures.heatingCopPhotovoltaic"
        label="{{ '+INSTALLATIONS.INSTALLATION.HEATING.COP.PHOTOVOLTAIC' | translate }}:"
        [value]="copFeatures.heatingCopPhotovoltaic | value2: featurePropertyKey.value"
        [attr.data-feature]="copFeatures.heatingCopPhotovoltaic.feature"
        [error]="copFeatures.heatingCopPhotovoltaic | error"
      ></app-feature-list-item>
    </div>
  </app-feature-list-container>
</ng-container>

<!-- SPF -->
<app-feature-list-container
  *ngIf="
    (isE3HeatPumpDevice$ | async) && (installationFeaturesStore.isAnySpfFeatureReady() | async)
  "
  [title]="'+INSTALLATIONS.INSTALLATION.DHW.SCOP_TITLE' | translate"
  [tooltipText]="'+INSTALLATIONS.INSTALLATION.DHW.SCOP_TITLE_TOOLTIP' | translate"
>
  <div class="feature-grid-container" viFeatureGrid viBorderBottom>
    <app-feature-list-item
      *ngIf="heatingSpfTotal | async | ready as feature"
      [label]="('+INSTALLATIONS.INSTALLATION.DHW.SCOP_TOTAL' | translate) + ':'"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    ></app-feature-list-item>
    <app-feature-list-item
      *ngIf="heatingSpfHeating$ | async | ready as feature"
      [label]="('+INSTALLATIONS.INSTALLATION.DHW.SCOP_HEATING' | translate) + ':'"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    ></app-feature-list-item>
    <app-feature-list-item
      *ngIf="heatingSpfDhw$ | async | ready as feature"
      [label]="('+INSTALLATIONS.INSTALLATION.DHW.DHW_SCOP' | translate) + ':'"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    ></app-feature-list-item>
    <app-feature-list-item
      *ngIf="heatingSeerCooling$ | async | ready as feature"
      [label]="('+INSTALLATIONS.INSTALLATION.SEER_COOLING' | translate) + ':'"
      [value]="feature | value2: featurePropertyKey.value"
      [attr.data-feature]="feature.feature"
    ></app-feature-list-item>
  </div>
</app-feature-list-container>

<!-- Date and time -->
<!-- Global styling attributes cause visual bugs -->
<ng-container *ngIf="offSetDeviceTime$ | async">
  <app-feature-list-container
    [title]="'+INSTALLATIONS.INSTALLATION.DATE_AND_TIME.HEADER' | translate"
  >
    <app-edit-device-time [device]="device"></app-edit-device-time>
  </app-feature-list-container>
</ng-container>

<app-smart-home-components></app-smart-home-components>
